import React from 'react'
import { TruncatedListParagraph } from '../../../legacy-design-system/paragraph/truncated-list-paragraph'

export function KeywordsCell({
  rowData: { keywords }
}: {
  readonly rowData: {
    readonly keywords: string[]
  }
}) {
  return (
    <TruncatedListParagraph
      values={keywords}
      lines={2}
      showAllTextId={'action_showAll_keywords'}
    />
  )
}
